import { SxProps, Theme } from '@mui/material';

export const ratingCardContainerSX: SxProps<Theme> = {
	padding: 0,
	marginBottom: '10px',
};

export const ratingSX: SxProps<Theme> = {
	padding: 0,
	'& .MuiRating-iconFilled': {
		color: 'primary.main',
	},
};

export const starIconSX: SxProps<Theme> = {
	opacity: 0.3,
	color: 'gray',
};

export const ratingsAndReviewsSX: SxProps<Theme> = {
	color: 'grey.300',
};
